import React from 'react';

export default function SanityCollapseGlitch({
  active,
  sanityFx,
  burst,
  lowFx = false,
  aggressiveLowFx = false,
}) {
  const collapseStrength = sanityFx?.collapseOverlay || 0;

  return (
    <div
      aria-hidden="true"
      className="dd-sanity-collapse-glitch"
      style={{
        opacity: active ? 1 : 0,
        '--dd-collapse-opacity': String(collapseStrength),
      }}
    >
      <style>{`
        .dd-sanity-collapse-glitch{
          position: fixed;
          inset: 0;
          z-index: 36;
          pointer-events: none;
          overflow: hidden;
          transition: opacity 180ms ease;
        }

        .dd-sanity-collapse-bed{
          position:absolute;
          inset:0;
          opacity: calc(0.26 * var(--dd-collapse-opacity));
          background:
            repeating-linear-gradient(
              to bottom,
              rgba(255,255,255,0.035) 0px,
              rgba(255,255,255,0.035) 1px,
              rgba(0,0,0,0) 2px,
              rgba(0,0,0,0) 4px
            ),
            radial-gradient(
              ellipse at center,
              rgba(110,40,180,0.08) 0%,
              rgba(30,0,50,0.10) 45%,
              rgba(0,0,0,0.18) 100%
            );
          mix-blend-mode: screen;
          animation: ddCollapseBedDrift 1.3s steps(2, end) infinite;
        }

        .dd-sanity-collapse-darkflash{
          position:absolute;
          inset:0;
          background: rgba(0,0,0,var(--dd-darkflash-alpha, 0.12));
        }

        .dd-sanity-collapse-chroma-left,
        .dd-sanity-collapse-chroma-right{
          position:absolute;
          inset:0;
          mix-blend-mode: screen;
          opacity: 0.18;
        }

        .dd-sanity-collapse-chroma-left{
          background: rgba(180, 70, 255, 0.20);
          transform: translateX(calc(var(--dd-chroma-shift, 2px) * -1));
        }

        .dd-sanity-collapse-chroma-right{
          background: rgba(80, 120, 255, 0.16);
          transform: translateX(var(--dd-chroma-shift, 2px));
        }

        .dd-sanity-collapse-slice{
          position:absolute;
          left:0;
          right:0;
          background:
            linear-gradient(
              to bottom,
              rgba(255,255,255,0.05),
              rgba(150,80,255,0.08),
              rgba(0,0,0,0.03)
            );
          mix-blend-mode: screen;
          backdrop-filter: blur(0px);
        }

        @keyframes ddCollapseBedDrift{
          0% { transform: translateY(0px); opacity: 0.22; }
          50% { transform: translateY(-1px); opacity: 0.30; }
          100% { transform: translateY(0px); opacity: 0.22; }
        }
      `}</style>

      {active && !lowFx && !aggressiveLowFx && <div className="dd-sanity-collapse-bed" />}

      {burst && (
        <>
          <div
            className="dd-sanity-collapse-darkflash"
            style={{
              '--dd-darkflash-alpha': aggressiveLowFx
                ? Math.max(0.10, (burst.darkFlashAlpha || 0) * 0.9)
                : lowFx
                  ? Math.max(0.08, (burst.darkFlashAlpha || 0) * 0.7)
                  : burst.darkFlashAlpha,
            }}
          />
          {!lowFx && !aggressiveLowFx && (
            <>
              <div
                className="dd-sanity-collapse-chroma-left"
                style={{ '--dd-chroma-shift': `${burst.chromaShiftPx}px` }}
              />
              <div
                className="dd-sanity-collapse-chroma-right"
                style={{ '--dd-chroma-shift': `${burst.chromaShiftPx}px` }}
              />

              {Array.isArray(burst.slices) &&
                burst.slices.map((slice, idx) => (
                  <div
                    key={`${burst.id}-slice-${idx}`}
                    className="dd-sanity-collapse-slice"
                    style={{
                      top: `${slice.topPct}%`,
                      height: `${slice.heightPx}px`,
                      opacity: slice.opacity,
                      transform: `translateX(${slice.shiftPx}px)`,
                    }}
                  />
                ))}
            </>
          )}
        </>
      )}
    </div>
  );
}